// 개발용 자동 로그인 유틸리티 (임시)

import { User } from '../store/authStore';

export const DEV_ADMIN_USER: User = {
  id: '550e8400-e29b-41d4-a716-446655440001',
  email: 'bookrum@bookrum.co.kr',
  name: '정영욱',
  roleId: 'role-1',
  roleName: 'executive',  // Fixed: Changed from 'admin' to 'executive'
  positionId: 'pos-1',
  positionName: 'CEO',     // Fixed: Changed from 'ceo' to 'CEO'
  departmentId: 'dept-2',
  departmentName: 'planning-production',
  employeeId: 'EMP001',
  isActive: true,
  joinDate: '2020-01-01',
  status: 'working',
  totalVacDays: 20,
  remainingVacDays: 15,
  createdAt: '2020-01-01T00:00:00.000Z',
  updatedAt: new Date().toISOString(),
};

export const enableDevAutoLogin = () => {
  // localStorage에 토큰 설정 (임시)
  localStorage.setItem('access_token', 'dev-token-admin');
  localStorage.setItem('refresh_token', 'dev-refresh-token');
  
  // Zustand persist 스토리지에 사용자 정보 설정
  const authData = {
    state: {
      user: DEV_ADMIN_USER,
      isAuthenticated: true
    },
    version: 0
  };
  
  localStorage.setItem('auth-storage', JSON.stringify(authData));
  
  console.log('🚀 개발용 자동 로그인 활성화됨 - Admin 계정:', DEV_ADMIN_USER.email);
};

export const disableDevAutoLogin = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('auth-storage');
  console.log('❌ 개발용 자동 로그인 비활성화됨');
};
